import { render, staticRenderFns } from "./TaskRevenueTemplates.vue?vue&type=template&id=4cc5ea59&scoped=true&"
import script from "./TaskRevenueTemplates.vue?vue&type=script&lang=js&"
export * from "./TaskRevenueTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TaskRevenueTemplates.vue?vue&type=style&index=0&id=4cc5ea59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5ea59",
  null
  
)

export default component.exports